import React from 'react';
import { useTranslation } from 'react-i18next';
import { Block, DefaultText, MediumText } from '@guryou/html-components';
import { getLocationInput } from 'modules/providers/containers/wizardComponents/utils';
import LocationPicker from 'onboard/components/LocationPicker';
import CheckboxInfoContainer from 'onboard/containers/CheckboxInfoContainer';
import FormContainer from 'onboard/containers/FormContainer';
import InfoContainer from 'onboard/containers/InfoContainer';
import MainContainer from 'onboard/containers/MainContainer';
import PlayGuideVideoEmbed from 'onboard/containers/PlayGuideVideoEmbed';
import TitleContainer from 'onboard/containers/TitleContainer';
import { useOnboardContext } from 'onboard/context';
import { guideVideos } from 'onboard/GuideVideosUrls';
import { dealTokens } from 'components/shared';

import StepButtons from '../StepButtons';

const ServiceLocation = () => {
  const { t } = useTranslation();
  const { serviceState, setServiceState } = useOnboardContext();

  const handleSubmit = data => {
    setServiceState({ location: getLocationInput(data) });
  };
  return (
    <MainContainer>
      <FormContainer handleSubmit={handleSubmit}>
        <TitleContainer title={t('ONBOARD.selectPreferredLocation')} />
        <Block lg={10} md={12} xs={12} margin={0} marginTop={6}>
          <LocationPicker location={serviceState.location} />
        </Block>
        <StepButtons />
      </FormContainer>
      <InfoContainer>
        <MediumText lineHeight="1.3">{t('ONBOARD_TEXT.serviceLocationTitle')}</MediumText>
        <DefaultText color={dealTokens.color.textMuted} marginTop={2}>
          {t('ONBOARD_TEXT.serviceLocationSubtitle')}
        </DefaultText>

        <div style={{ marginTop: dealTokens.space[6], paddingTop: dealTokens.space[5], borderTop: `1px solid ${dealTokens.color.border}` }}>
          <div
            style={{
              fontSize: 11,
              fontWeight: dealTokens.font.weightSemibold,
              letterSpacing: '0.06em',
              textTransform: 'uppercase',
              color: dealTokens.color.textMuted,
              marginBottom: dealTokens.space[4],
            }}
          >
            {t('ONBOARD_TEXT.serviceLocationCheckboxTitle')}
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: dealTokens.space[4] }}>
            <CheckboxInfoContainer text={t('ONBOARD_TEXT.serviceLocationCheckbox1Text')} />
            <CheckboxInfoContainer text={t('ONBOARD_TEXT.serviceLocationCheckbox2Text')} />
            <CheckboxInfoContainer text={t('ONBOARD_TEXT.serviceLocationCheckbox3Text')} />
          </div>
        </div>

        <PlayGuideVideoEmbed videoId={guideVideos.serviceLocation.videoId} modalTitle={guideVideos.serviceLocation.title} />
      </InfoContainer>
    </MainContainer>
  );
};

export default ServiceLocation;
